import { render, staticRenderFns } from "./AddProductCommentModal.vue?vue&type=template&id=152a0e46"
import script from "./AddProductCommentModal.vue?vue&type=script&lang=js"
export * from "./AddProductCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports